import { Box, Divider, List } from "@chakra-ui/react"
import React, { useEffect, useRef } from "react"
import { useInViewport } from "react-in-viewport"

import { ExtendedUserRouteRecordFragment } from "../../graphql"
import { UserRouteListItem } from "./UserRouteListItem"

export type UserRoutesListProps = {
	userRouteRecords: ExtendedUserRouteRecordFragment[]
	loadMore: () => void
}

export const UserRoutesList: React.FC<UserRoutesListProps> = ({ userRouteRecords, loadMore }) => {
	const ref = useRef()

	const { inViewport } = useInViewport(ref as any, { threshold: 0.25 })

	useEffect(() => {
		if (inViewport) {
			loadMore()
		}
	}, [inViewport, loadMore])

	return (
		<List spacing={2}>
			{userRouteRecords.map((userRouteRecord) => (
				<React.Fragment key={userRouteRecord._id}>
					<UserRouteListItem userRouteRecord={userRouteRecord} />
					<Divider />
				</React.Fragment>
			))}
			<Box w="full" h="2" ref={ref as any} />
		</List>
	)
}
